export default __webpack_public_path__ + "static/media/email.e366b49c.png";